import script from "./IndexSoical.vue?vue&type=script&lang=ts&setup=true"
export * from "./IndexSoical.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__